import React,{ useEffect, useRef } from "react";
import Icon from "@mdi/react";
import {mdiClose} from "@mdi/js";

const UEConfirmModal = ({
                         title,
                         isOpened,
                         onProceed,
                         onClose,
                         showButtons=true,
                         children,
                     }) => {
    const modalDialog = useRef(null);

    useEffect(() => {
        if (isOpened) {
            modalDialog?.current?.showModal();
            //document.body.classList.add("modal-open"); // prevent bg scroll
        } else {
            modalDialog?.current?.close();
            //document.body.classList.remove("modal-open");
        }
    }, [isOpened]);

    const proceedAndClose = (e) => {
        e.stopPropagation(true);
        onProceed();
        onClose();
    };
    const handleOnClose=(e)=>{
        e.stopPropagation(true);
        onClose();
    }

    return (
        <dialog id="ue_confirm_dialog" style={{"maxWidth": "600px"}} ref={modalDialog}>
            <header>
                <h4>{title}</h4>
                <div className={'ue-admin-modal-btn-icon-sm'} onClick={handleOnClose}>
                    <Icon className={"mx-2"} path={mdiClose} size={0.8} color={"#FFFFFF"} />
                </div>
            </header>
            <div className={"modal-body"}>
                {children}
            </div>
            {showButtons ?
            <footer>
                <div className={"d-flex justify-content-end align-items-center"}>
                    <button className={"btn btn-outline-primary mx-2"} onClick={handleOnClose}>Annuler</button>
                    <button className={"btn btn-primary text-white"} onClick={proceedAndClose}>Valider</button>
                </div>
            </footer>
                :null}

        </dialog>
    );
};

export default UEConfirmModal;
